import { TemaCard } from 'src/data/models/TemaCardModel';

export const everydayEncountersCards: TemaCard[] = [
    // 🙋 Asking for help & basic needs (most urgent)
    new TemaCard(
        'help1',
        'Everyday Encounters',
        'phrase',
        '¿Puede ayudarme, por favor?',
        'Can you help me, please?',
        'Polite way to ask for assistance.'
    ),
    new TemaCard(
        'help2',
        'Everyday Encounters',
        'sentence',
        'Estoy perdido. ¿Cómo llego a la estación?',
        'I’m lost. How do I get to the station?',
        'Useful when navigating unfamiliar areas.'
    ),

    // 🧭 Asking for directions
    new TemaCard(
        'ask5',
        'Everyday Encounters',
        'phrase',
        '¿Dónde está...? ',
        'Where is...? ',
        'Common phrase used to ask for directions in stores, streets, etc.'
    ),
    new TemaCard(
        'dir1',
        'Everyday Encounters',
        'word',
        'dirección',
        'direction',
        'Core navigation vocabulary for moving around cities.',
        [
            { spanish: 'izquierda', english: 'left' },
            { spanish: 'derecha', english: 'right' },
            { spanish: 'esquina', english: 'corner' },
            { spanish: 'cerca', english: 'near' },
            { spanish: 'lejos', english: 'far' },
            { spanish: 'cruce', english: 'intersection' },
        ]
    ),
    new TemaCard(
        'dir2',
        'Everyday Encounters',
        'word',
        'recto',
        'straight',
        'Common terms used when describing direction on the road.',
        [
            { spanish: 'recto', english: 'straight' },
            { spanish: 'al frente', english: 'straight ahead' },
            { spanish: 'sigue derecho', english: 'keep going straight' },
        ]
    ),
    new TemaCard(
        'dir3',
        'Everyday Encounters',
        'word',
        'giro',
        'turn',
        'Terms for actions when turning or navigating intersections.',
        [
            { spanish: 'vuelta', english: 'turn' },
            { spanish: 'doblar', english: 'to turn' },
            { spanish: 'giro', english: 'turn' },
        ]
    ),
    new TemaCard(
        'dir4',
        'Everyday Encounters',
        'word',
        'ubicación',
        'location',
        'Useful words to describe relative locations and distances.',
        [
            { spanish: 'cerca de', english: 'close to' },
            { spanish: 'a la derecha', english: 'to the right' },
            { spanish: 'a la izquierda', english: 'to the left' },
            { spanish: 'lejos de', english: 'far from' },
            { spanish: 'delante', english: 'in front' },
            { spanish: 'detrás', english: 'behind' },
            { spanish: 'alrededor', english: 'around' },
        ]
    ),
    new TemaCard(
        'dir5',
        'Everyday Encounters',
        'word',
        'calles',
        'streets',
        'Common terms for streets and paths that help in navigation.',
        [
            { spanish: 'barrio', english: 'neighborhood' },
            { spanish: 'avenida', english: 'avenue' },
            { spanish: 'calle', english: 'street' },
            { spanish: 'paseo', english: 'walkway' },
            { spanish: 'camino', english: 'path' },
        ]
    ),
    new TemaCard(
        'dir6',
        'Everyday Encounters',
        'word',
        'dirección',
        'direction',
        'Additional vocabulary for precise direction instructions.',
        [
            { spanish: 'dirección', english: 'direction' },
            { spanish: 'en el cruce', english: 'at the intersection' },
            { spanish: 'bajo', english: 'down' },
            { spanish: 'arriba', english: 'up' },
        ]
    ),

    // 🚶 Asking for things
    new TemaCard(
        'ask1',
        'Everyday Encounters',
        'phrase',
        '¿Tiene...?',
        'Do you have...?',
        'General asking phrase for shops, restaurants, etc.'
    ),
    new TemaCard(
        'ask2',
        'Everyday Encounters',
        'sentence',
        '¿Puede darme una bolsa, por favor?',
        'Can you give me a bag, please?',
        'Common when shopping.'
    ),
    new TemaCard(
        'ask3',
        'Everyday Encounters',
        'phrase',
        '¿Me puede recomendar...? ',
        'Can you recommend...? ',
        'Used to ask for suggestions in shops, restaurants, or places to visit.'
    ),
    new TemaCard(
        'ask4',
        'Everyday Encounters',
        'phrase',
        '¿Cómo se dice... en español? ',
        'How do you say... in Spanish? ',
        'Useful for language learners when asking for translations.'
    ),

    // 🏪 Common Places
    new TemaCard(
        'places1',
        'Everyday Encounters',
        'word',
        'tienda',
        'store',
        'Essential places for daily errands.',
        [
            { spanish: 'farmacia', english: 'pharmacy' },
            { spanish: 'supermercado', english: 'supermarket' },
            { spanish: 'panadería', english: 'bakery' },
            { spanish: 'banco', english: 'bank' },
        ]
    ),
    new TemaCard(
        'places2',
        'Everyday Encounters',
        'word',
        'restaurante',
        'restaurant',
        'Common places for dining and eating out.',
        [
            { spanish: 'cafetería', english: 'cafeteria' },
            { spanish: 'pizzería', english: 'pizzeria' },
            { spanish: 'asador', english: 'grill' },
            { spanish: 'heladería', english: 'ice cream shop' },
        ]
    ),
    new TemaCard(
        'places3',
        'Everyday Encounters',
        'word',
        'hospital',
        'hospital',
        'Important places for medical care.',
        [
            { spanish: 'clínica', english: 'clinic' },
            { spanish: 'farmacia', english: 'pharmacy' },
            { spanish: 'consultorio', english: 'doctor’s office' },
            { spanish: 'urgencias', english: 'emergency room' },
        ]
    ),
    new TemaCard(
        'places5',
        'Everyday Encounters',
        'word',
        'parque',
        'park',
        'Common outdoor recreational spaces.',
        [
            { spanish: 'playa', english: 'beach' },
            { spanish: 'zona de juegos', english: 'playground' },
            { spanish: 'sendero', english: 'trail' },
            { spanish: 'jardín', english: 'garden' },
        ]
    ),
    new TemaCard(
        'places4',
        'Everyday Encounters',
        'word',
        'biblioteca',
        'library',
        'Common places to study, read, or borrow books.',
        [
            { spanish: 'librería', english: 'bookstore' },
            { spanish: 'centro de estudios', english: 'study center' },
            { spanish: 'aula', english: 'classroom' },
            { spanish: 'sala de lectura', english: 'reading room' },
        ]
    ),
    new TemaCard(
        'places6',
        'Everyday Encounters',
        'word',
        'escuela',
        'school',
        'Common places for learning and education.',
        [
            { spanish: 'universidad', english: 'university' },
            { spanish: 'colegio', english: 'high school' },
            { spanish: 'guardería', english: 'daycare' },
            { spanish: 'instituto', english: 'institute' },
        ]
    ),

    // 🕐 Time & Scheduling
    new TemaCard(
        'time3',
        'Everyday Encounters',
        'phrase',
        '¿Qué hora es?',
        'What time is it?',
        'Very basic but essential question for navigating daily life.'
    ),
    new TemaCard(
        'time4',
        'Everyday Encounters',
        'phrase',
        '¿A qué hora abre/cierra?',
        'What time does it open/close?',
        'Frequently used when asking about store or office hours.'
    ),
    new TemaCard(
        'time2',
        'Everyday Encounters',
        'word',
        'minuto',
        'minute',
        'Helps to understand or describe short time durations.',
        [
            { spanish: 'segundo', english: 'second' },
            { spanish: 'media hora', english: 'half an hour' },
            { spanish: 'una hora', english: 'an hour' },
        ]
    ),
    new TemaCard(
        'time5',
        'Everyday Encounters',
        'word',
        'calendario',
        'calendar',
        'Useful when planning schedules or appointments.',
        [
            { spanish: 'fecha', english: 'date' },
            { spanish: 'día', english: 'day' },
            { spanish: 'semana', english: 'week' },
            { spanish: 'mes', english: 'month' },
        ]
    ),
];
